import { GroupTp } from './../../../viewModels/group-tp';
import { Component, OnInit } from '@angular/core';
import { GroupTpFormComponent } from './group-tp-form/group-tp-form.component';
import { MatTableDataSource } from '@angular/material/table';
import { Section } from 'src/app/viewModels/section';
import { HiararchyService } from 'src/app/apis/hiararchy.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { Sector } from 'src/app/viewModels/sector';

@Component({
  selector: 'app-groups-tp',
  templateUrl: './groups-tp.component.html',
  styleUrls: ['./groups-tp.component.css']
})
export class GroupsTpComponent implements OnInit {

  
  items: GroupTp[]=[];

  displayedColumns: string[] = [ 'designation', 'abbreviation','section','group_td' , 'actions'];
  dataSource = new MatTableDataSource<GroupTp>(this.items);
  selectedSection :number;
  selectedSector : number;
  sections : Section[]= []
  sectors: Sector[] = [];

  constructor(
    private apis: HiararchyService,
    public translate: TranslateService,
    private router: Router,
    private toastr: ToastrService,
    public dialog: MatDialog

  ) { }

  item: GroupTp = new GroupTp();
  show_form = false;


  ngOnInit(): void {

    this.getSectors()
  }

  getSectors() {
    this.apis.getHiararchySectors()
      .subscribe((data: Sector[]) => {
        this.sectors = data;
        if (this.sectors && this.sectors.length > 0) {
          this.selectedSector = this.sectors[0].id;
          this.getSections();
        } else {

        }
      })
  }

  getSections() {
    if (this.selectedSector) {
      this.apis.getSectorSections(this.selectedSector)
        .subscribe((data: Section[]) => {
          this.sections = data;
          if (this.sections && this.sections.length > 0) {
            this.selectedSection = this.sections[0].id;
            this.getGrouptps();
          } else {

          }
        })
    }

  }



  getGrouptps() {
if(this.selectedSection){
  this.apis.getSectionGroupTps( this.selectedSection)
  .subscribe((data: GroupTp[]) => {
    this.items = data;
    console.log(this.items)
    this.dataSource = new MatTableDataSource<GroupTp>(this.items);
  })
}
   
  }




  save() {
    console.log(this.item)
    this.apis.createOrUpdateGroupTp(this.item)
      .subscribe((data) => {
        this.getGrouptps()
        this.showSuccess('saved');
        this.item = new GroupTp();
      })
  }

  edit(element) {
    this.item = element
  }

  remove(id) {
    Swal.fire({
      title: this.translate.instant('alerts.delete_title'),
      text: this.translate.instant('alerts.delete_text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('alerts.delete_yes'),
      cancelButtonText: this.translate.instant('alerts.delete_no')
    }).then((result) => {
      if (result.value) {
        this.apis.removeGroupTp(id)
          .subscribe(() => {
            this.getGrouptps();
            Swal.fire(
              this.translate.instant('alerts.deleted'),
              this.translate.instant('alerts.deleted_text'),
              'success'
            )
          })

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.translate.instant('alerts.canceled'),
          this.translate.instant('alerts.canceled_text'),
          'error'
        )
      }
    })
  }

  showSuccess(msg) {

    this.toastr.success(this.translate.instant(msg))
  }

  showError(msg) {
    this.toastr.error(this.translate.instant((msg)))
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(GroupTpFormComponent, {
      width: '500px',
      data: this.item
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      console.log(this.item)
      if (result) {
        this.apis.createOrUpdateGroupTp(result)
          .subscribe(() => {
            this.showSuccess('saved');
            this.getGrouptps();

            this.item = new GroupTp()
          })
      }

    });
  }

  openEditDialog(subject): void {
    this.item = subject;
    const dialogRef = this.dialog.open(GroupTpFormComponent, {
      width: '500px',
      data: this.item
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      console.log(this.item)
      if (result) {
        this.apis.createOrUpdateGroupTp(result)
          .subscribe(() => {
            this.showSuccess('saved');
            this.getGrouptps();

            this.item = new GroupTp()
          })
      }

    });
  }

  filter(v){
    this.dataSource.filter = v.trim().toLowerCase();
  }

  changeSector(){
    this.getSections();
  }
  changeSection() {
   
    this.getGrouptps()
  }
}
